// extracted by mini-css-extract-plugin
export default {"select":"Select_select__BPTS6","disabled":"Select_disabled__yhzRy","active":"Select_active__tRy-J","filled":"Select_filled__OdbOe","icon":"Select_icon__-LctT"};